import { render } from "./RegisterClient.vue?vue&type=template&id=26580cc4&scoped=true"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"

import "./RegisterClient.vue?vue&type=style&index=0&id=26580cc4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26580cc4"]])

export default __exports__